import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { X } from 'lucide-react';
import { formatDisplayValue } from '../utils/gridOperations';

const FullscreenAlgaeModal = ({
  isOpen,
  onClose,
  organisms,
  customOrganisms,
  locations,
  gridData,
  depthOverrides,
  updateGridValue,
  handleInputBlur,
  getColorForValue,
  handleRightClick
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-white">
      <div className="h-full flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-slate-200 bg-slate-50">
          <h2 className="text-2xl font-bold text-slate-900">Algeprøver - Fullskjerm</h2>
          <Button
            onClick={onClose}
            variant="ghost"
            size="sm"
          >
            <X className="w-5 h-5" />
          </Button>
        </div>
        <div className="flex-1 overflow-auto p-6">
          <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
            <div className="relative overflow-auto">
              <table className="w-full border-collapse">
                <thead className="sticky top-0 z-50 bg-slate-50">
                  <tr>
                    <th className="sticky left-0 z-[60] border-r border-b border-slate-300 px-3 py-2 text-left text-sm font-semibold bg-slate-50" style={{width: '130px'}}>
                      Orden/gruppe
                    </th>
                    <th className="sticky z-[60] border-r border-b border-slate-300 px-3 py-2 text-left text-sm font-semibold bg-slate-50" style={{left: '130px', width: '150px'}}>
                      Evt. art
                    </th>
                    <th className="sticky z-[60] border-r border-b border-slate-300 px-2 py-2 text-center text-sm font-semibold bg-slate-50" style={{left: '280px', width: '60px'}}>
                      <div className="text-xs font-bold">Djup</div>
                      <div className="text-xs text-slate-500">(m)</div>
                    </th>
                    {locations.map((loc, index) => {
                      const letter = String.fromCharCode(65 + index);
                      const name = loc.split(' - ')[1];
                      return (
                        <th key={loc} className="border-r border-slate-300 px-2 py-2 text-center text-sm font-semibold bg-white min-w-20">
                          <div className="text-xs font-bold">{letter} - {name}</div>
                          <div className="text-xs text-slate-500">(ant/l)</div>
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {[...organisms, ...customOrganisms].map((organism) => {
                    const isSum = organism.isSum;
                    const organismKey = `${organism.group}_${organism.species}`;
                    
                    return (
                      <tr key={organismKey} className={isSum ? 'bg-slate-100' : 'hover:bg-slate-50'}>
                        <td className="sticky left-0 z-40 border-r border-b border-slate-300 px-3 py-2 text-sm bg-white" style={{width: '130px'}}>
                          {organism.group}
                        </td>
                        <td className="sticky border-r border-b border-slate-300 px-3 py-2 text-sm italic bg-white" style={{zIndex: 40, left: '130px', width: '150px'}}>
                          {organism.species}
                        </td>
                        <td className="border-r border-b border-slate-300 px-2 py-2 text-center text-sm">
                          {organism.depth}
                        </td>
                        {locations.map((location) => {
                          const cellKey = `${organismKey}_${location}`;
                          const bgColor = getColorForValue(gridData[organismKey]?.[location] || '', organism.group, organism.species, organismKey, location);
                          
                          return (
                            <td key={location} className="border-r border-b border-slate-300 p-1"
                              onContextMenu={(e) => handleRightClick(e, organismKey, location)}
                            >
                              {isSum ? (
                                <div className="h-8 flex items-center justify-center text-sm font-semibold bg-slate-200 rounded">
                                  {(() => {
                                    const rawValue = gridData[organismKey]?.[location];
                                    if (!rawValue || rawValue === '0') return '0';
                                    const numValue = parseInt(String(rawValue).replace(/[^\d-]/g, ''));
                                    if (isNaN(numValue)) return rawValue || '0';
                                    return numValue.toLocaleString('nb-NO');
                                  })()}
                                </div>
                              ) : (
                                <Input 
                                  value={formatDisplayValue(gridData[organismKey]?.[location] || '')}
                                  onChange={(e) => updateGridValue(organismKey, location, e.target.value)}
                                  onBlur={(e) => handleInputBlur(e, organismKey, location)}
                                  className={`h-8 text-sm text-center border-0 focus:ring-1 focus:ring-teal-500 ${bgColor}`}
                                />
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FullscreenAlgaeModal;
